import styled from 'styled-components';

import { Spacer } from '@ontruck/orc';

const StyledWrapper = styled(Spacer)`
  position: sticky;
  top: 0;
  z-index: 98;
  width: 100%;
  background: var(--primary-filters);
  margin: 0 auto;
  padding: 8px 14px 0.1px;
  > div {
    margin-bottom: 8px;
  }
`;

export { StyledWrapper };
